import React, { useEffect } from "react";
import { Div } from "components/Base";
import MiniModalWrapper from "ui-kit/MiniModalWrapper";
import { hideModal } from "redux/modules/modal/actions";
import { connect } from "react-redux";
import { actions, getters } from "../model";
import Footer from "./Footer";
import Loading from "ui-kit/Loading";
import css from "./styles.scss";
import Label from "ui-kit/FormLabel";
import { Input, WithFormInstanceProvider } from "ui-kit/Form/View";
import { STYLE_LABELS, FORM_ID } from "../constants";
import * as R from "ramda";
import { disabledSaveButton, isEmailValid } from "../selectors";
import { noop } from "utils/General";

import { useMobile } from "Portal/NewPortal/Shared/UseMobile";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(FORM_ID)),
  connect(
    state => ({
      loading: getters.loading(state),
      processing: getters.processing(state),
      disabledSaveButton: disabledSaveButton(state),
      isEmailValid: isEmailValid(state)
    }),
    {
      hideModal: hideModal,
      setExistingUserData: actions.setExistingUserData,
      save: actions.save
    }
  )
);

const Layout = ({
  hideModal,
  loading = true,
  processing = false,
  disabledSaveButton = true,
  isEmailValid = true,
  userDataToEdit = {},
  setExistingUserData = noop,
  onDone = noop,
  save = noop
}) => {
  useEffect(() => {
    if (!R.isEmpty(userDataToEdit)) {
      setExistingUserData(userDataToEdit);
    }
  }, []);

  const isMobile = useMobile();

  const styleLabel = STYLE_LABELS;
  return (
    <MiniModalWrapper
      hideModal={hideModal}
      title="Add Additional Contact"
      isPortal={true}
      showHeader={false}
      showModal
      style={{
        width: isMobile ? "95%" : "475px",
        height: isMobile ? "100%" : "427px"
      }}
      stopPropagation
    >
      {loading ? (
        <Div bg="white" flex={1} className={css.fullHeight}>
          <Loading />
        </Div>
      ) : (
        <Div bg="white" flex={1} display="column.space-between.stretch">
          <Div
            color="black"
            fw={3}
            bb={1}
            pb={3}
            mb={2}
            fs={3}
            p={5}
            bc="gray3"
          >
            Add Additional Contact
          </Div>

          <Div
            display="column.center.center"
            px={5}
            flex={1}
            className={css.fullHeight}
          >
            <Div display="row" mb={5} width={1}>
              <Div width={0.5} mr={4}>
                <Label bold style={styleLabel} required>
                  First Name
                </Label>
                <Input
                  autoFocus={true}
                  fieldId="firstName"
                  width={1}
                  placeholder="Enter name"
                  iniValue={R.prop("firstName")(userDataToEdit)}
                  size="big"
                  inputType="outline"
                />
              </Div>
              <Div width={0.5}>
                <Label bold style={styleLabel} required>
                  Last Name
                </Label>
                <Input
                  fieldId="lastName"
                  placeholder="Enter last name"
                  width={1}
                  iniValue={R.prop("lastName")(userDataToEdit)}
                  size="big"
                  inputType="outline"
                />
              </Div>
            </Div>
            <Div display="column" mb={5} width={1}>
              <Label bold required style={styleLabel}>
                Email
              </Label>
              <Input
                fieldId="email"
                type="email"
                width={1}
                iniValue={R.prop("email")(userDataToEdit)}
                size="big"
                placeholder="Enter email"
                inputType="outline"
                style={
                  !isEmailValid
                    ? {
                        borderColor: "#c92a2a"
                      }
                    : {}
                }
              />
              {!isEmailValid ? (
                <Label
                  aria-label="Error: please enter a valid email address"
                  color={"danger9"}
                >
                  Please enter a valid email
                </Label>
              ) : null}
            </Div>
            <Div display="column" mb={5} width={1}>
              <Label bold style={styleLabel}>
                Role
              </Label>
              <Input
                fieldId="role"
                width={1}
                iniValue={R.prop("role")(userDataToEdit)}
                size="big"
                placeholder="Add role"
                inputType="outline"
              />
            </Div>
          </Div>
          <Footer
            processing={processing}
            disableConfirmButton={disabledSaveButton}
            onConfirm={() => save({ onDone })}
            onCancel={hideModal}
          />
        </Div>
      )}
    </MiniModalWrapper>
  );
};

export default decorate(Layout);
